(function () {
  var bar = document.getElementById('sticky-atc-bar');
  var stickyBtn = document.getElementById('sticky-atc-bar-btn');
  if (!bar || !stickyBtn) return;

  function getMainAtcBtn() {
    return document.querySelector('.product-form-buttons .add-to-cart-button');
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var mainBtn = getMainAtcBtn();
      if (!mainBtn) return;
      var rect = mainBtn.getBoundingClientRect();
      var outOfView = rect.bottom < 0 || rect.top > window.innerHeight;
      bar.classList.toggle('sticky-atc-bar--visible', outOfView);
      bar.setAttribute('aria-hidden', outOfView ? 'false' : 'true');
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  stickyBtn.addEventListener('click', function () {
    var mainBtn = getMainAtcBtn();
    if (!mainBtn || mainBtn.disabled) return;
    mainBtn.click();
    var orig = stickyBtn.textContent.trim();
    stickyBtn.textContent = 'Added ✓';
    setTimeout(function () { stickyBtn.textContent = orig; }, 2000);
  });
})();